<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <div class="d-flex align-center justify-space-between">
            <p class="font-weight-bold text-primary">لیست افزونه ها</p>
            <v-select
                label="دسته بندی"
                item-title="name"
                item-value="id"
                no-data-text="موردی پیدا نشد!"
                hide-details
                :items="categoryItems"
                v-model="category"
                style="max-width: 220px;"
            ></v-select>
        </div>
        <v-row class="mt-0">
            <v-col cols="12" sm="6" lg="4" v-for="(item, index) in filteredItems" :key="index">
                <v-card class="h-100 d-flex flex-column" border>
                    <v-row class="px-4 pt-4">
                        <v-col cols="auto" class="pe-0">
                            <v-img :src="`${item.icon}`" width="44" height="44" class="rounded-lg"></v-img>
                        </v-col>
                        <v-col>
                            <h5 class="mb-1">{{item.name}}</h5>
                            <p class="text-small text-grey-darken-2">{{categoryItems.find(x => x.id == item.category).name}}</p>
                        </v-col>
                    </v-row>
                    <p class="text-small flex-fill text-justify text-grey-darken-2 px-4">{{item.excerpt}}</p>
                    <div class="px-4 pb-4" :class="item.accessConfig ? 'mt-6' : 'mt-n2'">
                        <p class="text-small my-1 text-center text-error" v-if="!item.accessConfig">این افزونه در پلن خریداری شده شما پشتیبانی نمی شود</p>
                        <v-btn block color="secondary" @click="$router.push({path: `/settings/plugins/${item.slug}`})">
                            <v-icon class="me-1" size="16">{{ item.accessConfig ? 'icon-settings' : 'icon-Info'}}</v-icon>
                            <span>{{ item.accessConfig ? 'جزئیات و پیکربندی' : 'جزئیات بیشتر'}}</span>
                        </v-btn>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import pluginsSearchBox from '@/variables/pluginsSearchBox';
export default {
    title: "افزونه ها",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            loading: false,
            items: pluginsSearchBox(),
            category: false,
            categoryItems: [
                {
                    id: false,
                    name: 'همه دسته بندی ها',
                },
                {
                    id: 1,
                    name: 'ویپ',
                },
                {
                    id: 2,
                    name: 'پیامک',
                },
                {
                    id: 3,
                    name: 'احراز هویت',
                },
                {
                    id: 4,
                    name: 'چت آنلاین'
                }
            ]
        };
    },
    methods: {

    },
    computed: {
        filteredItems() {
            return this.items.filter(x => this.category === false || this.category == x.category);
        }
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            this.$loading.finish();
        });
    },
};
</script>
